export default __webpack_public_path__ + "static/media/v4.eb74152a.jpg";